import { Injectable } from '@angular/core';
import { Query, toBoolean } from '@datorama/akita';
import { filter } from 'rxjs/operators';
import { SessioneUtenteState, SessioneUtenteStore } from './utente-sessione.store';

@Injectable({ providedIn: 'root' })
export class SessioneUtenteQuery extends Query<SessioneUtenteState> {
  constructor(protected store: SessioneUtenteStore) {
    super(store);
  }
  isLoggedIn$ = this.select(({ utente }) => toBoolean(utente));

  loggedInUser$ = this.select().pipe(filter(({ utente }) => toBoolean(utente)));

  loggedInUserChange$ = this.select();

  isLoggedIn() {
    return toBoolean(this.getValue().utente);
  }
  loggedUser() {
    return this.getValue().utente;
  }

  setTokenCorsi(token_corsi: string) {
    this.store.update({ utente: { ...this.loggedUser(), token_corsi } });
  }

  updateBypassCanDeactivate(bypassCanDeactivate: boolean) {
    this.store.update({ utente: { ...this.loggedUser(), bypassCanDeactivate: bypassCanDeactivate } });
  }
}
